import { Component } from '@angular/core';
import { Wrapper } from '../../components/wrapper.component';
import { AddItemRowData, Budget, BudgetQuoteSection, BudgetSection, createEmptyBudgetSchedule, createEmptySection, LineItem, manageBudgetAssetsDropdownOptions, ManageBudgetLinkOption, manageQuoteLinkDropdownOptions, SectionSettings } from '../../store/reselectors/budget.data';
import { OnInit } from '@angular/core';
import { JoiEvent } from 'src/app/store/events.era';
import { CURRENCY_OPTIONS } from '../../store/reselectors/currencies.data';
import { eventReadOnlyReselector, eventStatusReselector } from '../../store/reselectors/events.reselector';
import { PaymentGridData, BudgetSectionGridData } from '../../helpers/grid-helpers';
import { costSchedulesReselector, sectionsReselector, linkableSectionHasChangesMapReselector, costTasksToggleSectionReselector, hasChangedBudgetTasksReselector, costAssetsToggleSectionReselector, hasChangedBudgetAssetsReselector } from '../../store/reselectors/budget.reselector';
import { Dictionary } from '@ngrx/entity';
import { moveIndexItemUpInList, moveIndexItemDownInList, deleteItemFromListById } from '../../helpers/helpers';
import { applyItemTemplateToLineItemInPlace } from '../../helpers/budget-helpers';
import { ButtonListData, ButtonListDialogComponent } from '../../components/dialogues-general/buttonList.dialog.component';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { linkableQuotesReselector } from '../../store/reselectors/quotes.reselector';
import { ManageQuoteDialogComponent } from '../resources/manage-quote.component';
import { UpdatesAvailableData, UpdatesAvailableDialogComponent } from './updates-available-dialog.component';
import { ManageQuoteData } from '../../store/reselectors/quotes.data';
import { LineItemsDialogData, LineItemsDialogComponent } from './line-items.dialog.component';
import { AddBudgetToggleItemsData, AddBudgetToggleItemsDialogComponent } from './add-budget-toggle-items.dialog.component';
import { manageBudgetTasksDropdownOptions } from './../../store/reselectors/budget.data';
import { BudgetSnapshotDialogData, BudgetCostsViewDialogComponent } from './costs-view-dialog.component';
import { hideTipSelector } from '../../store/reselectors/user.reselector';
import { exportBudgetSections } from '../performers/performerSharedFunctions';
import { EventStatus, SnapshotInfo } from 'globals/store/events.data';
import { JoiAccount, LineItemTemplate } from 'globals/store/accounts.data';
import { Asset } from 'globals/store/assets.data';
import { createId, jsonCopyObject } from 'globals/helpers/helpers';
import { unlinkSectionInPlace } from 'globals/helpers/budget.helper';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { TopMenuComponent } from '../program/top.menu';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { EventStatusComponent } from 'src/app/components/events/event-status.component';
import { ActionButtonComponent } from 'src/app/components/nav-bar/action-button.component';
import { CommonModule } from '@angular/common';
import { BudgetTotalsStripComponent } from './budget-totals-strip.component';
import { BudgetSectionComponent } from './budget-section.component';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { traceNames } from 'src/app/services/performance.tracking.data';

@Component({
    selector: 'budget-costs',
    templateUrl: './costs.html',
    styleUrls: ['../../page.scss', './revenue.scss', '../../components/timeline/timeline.component.scss', '../../components/timeline/snapshot.scss'],
    styles: [`
  .snapshot { margin-left: 10px; cursor: pointer; }
  
  `],
    standalone: true,
    imports: [LoaderPaneFragmentComponent, TopMenuComponent, TipTextComponent, EventStatusComponent, ActionButtonComponent, CommonModule, BudgetTotalsStripComponent, TipTextComponent, BudgetSectionComponent, BudgetSectionComponent, MatButtonModule, MatMenuModule, MatProgressSpinnerModule],
})
export class BudgetCostsComponent extends Wrapper<BudgetCostsComponent> implements OnInit {
  budget: Budget
  event: JoiEvent
  eventStatus: EventStatus
  readOnly = false
  closed = true
  traceNames = traceNames;

  savingSnapshot = false
  savingVersion = false
  currencyOptions = CURRENCY_OPTIONS
  scheduleGridDatas: Dictionary<PaymentGridData[]> = {}
  sectionGridDatas: Dictionary<BudgetSectionGridData[]> = {}
  linkableQuoteSections: BudgetQuoteSection[]
  linkedChangedSectionsMap: Dictionary<BudgetSection> = {}
  hasChangedTasks = false
  taskUpdatesOpen = false
  hasChangedAssets = false
  assetUpdatesOpen = false

  costTasksToggleSection: BudgetSection // a "fake" budget section for the manage tasks dialog
  costAssetsToggleSection: BudgetSection // a "fake" budget section for the manage assets dialog

  manageQuoteLinkDropdownOptions = manageQuoteLinkDropdownOptions
  manageBudgetTasksDropdownOptions = manageBudgetTasksDropdownOptions
  manageBudgetAssetsDropdownOptions = manageBudgetAssetsDropdownOptions
  costTip = "Enter all your costs associated with delivering the event . You can send quote requests to your resources and have the quotes link directly to costs. Go to the summary tab to see the difference between revenue and costs"
  hideTip = true
  account: Partial<JoiAccount>
  assets: Dictionary<Asset>

  ngOnInit() {
    this.selectProp(hideTipSelector, 'cost', 'hideTip')
    this.subProp(this.store.select('accounts', 'account'), 'account')
    this.subProp(this.store.select('budget', 'budget'), 'budget')
    this.subProp(this.store.select('assets', 'entities'), 'assets')
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select(eventStatusReselector), 'eventStatus')
    this.subProp(this.store.select(costSchedulesReselector), 'scheduleGridDatas')
    this.subProp(this.store.select(sectionsReselector), 'sectionGridDatas')
    this.selectProp(linkableQuotesReselector, null, 'linkableQuoteSections')
    this.selectProp(costTasksToggleSectionReselector, null, 'costTasksToggleSection')
    this.selectProp(costAssetsToggleSectionReselector, null, 'costAssetsToggleSection')
    this.selectProp(hasChangedBudgetTasksReselector, null, 'hasChangedTasks')
    this.selectProp(hasChangedBudgetAssetsReselector, null, 'hasChangedAssets')
    this.subProp(this.store.select(linkableSectionHasChangesMapReselector), 'linkedChangedSectionsMap')
    this.selectProp(eventReadOnlyReselector, null, 'closed')
  }

  changeCurrency(currency: string) {
    this.budget.currency = currency
    this.userService.updateSettings({ budgetCurrency: currency })
    this.saveBudget()
  }

  
  async viewUpdates(section: BudgetSection, updatedSection: BudgetSection, isQuote = false) {
    const data: UpdatesAvailableData = {
      previousSection: section.linkedCache,
      updatedSection: updatedSection,
      budget: this.budget,
      showSchedules: true,
      isRevenue: false
    }
    const update = await openDialogGetResult(this.dialog, UpdatesAvailableDialogComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
    if (update) {
      const copiedSection = jsonCopyObject(updatedSection)
      copiedSection.linkId = copiedSection.id
      copiedSection.isQuote = isQuote
      copiedSection.id = section.id
      copiedSection.linkedCache = jsonCopyObject(updatedSection)
      this.budget.sections[section.id] = copiedSection
      this.saveBudget()
    }
  }

  export() {
    exportBudgetSections(this.budget, this.budget.costIds, 'costs', this.dialog)
  }

  async addItem({ event, row }: AddItemRowData<BudgetSectionGridData>, costId: string) {
    console.log("Should be adding item...", { event, row })
    const data: LineItemsDialogData = {
      x: event.x - 100,
      y: event.y + 27
    }
    const item = await openDialogGetResult<LineItemTemplate>(this.dialog, LineItemsDialogComponent, {
      width: '200px',
      autoFocus: false,
      data,
      disableClose: true,
    })

    if (item) {
      applyItemTemplateToLineItemInPlace(this.budget.currency, this.budget.sections[costId], row.id, item, true)
      this.saveBudget()
    }

  }

  async linkQuoteSection(event) {
    
    const data: ButtonListData<BudgetQuoteSection> = {
      x: event.x - 125,
      y: event.y + 27,
      title: 'Quotes',
      choiceObjects: this.linkableQuoteSections,
      choiceKey: 'name',
      secondaryChoiceKey: 'resourceName',
      selected: null,
      selectedKey: 'id',
      successLabel: 'Add',
      cancelLabel: 'Cancel'
    }
    const { selected, cancelled, submitted } = await openDialogGetResult<{ selected: string, cancelled: boolean, submitted: boolean }>(this.dialog, ButtonListDialogComponent, {
      width: '300px',
      autoFocus: false,
      data,
      backdropClass: 'clear',
    })
    if (!selected || (!submitted && !cancelled)) return

    const section = data.choiceObjects.find(o => o.id === selected) as BudgetSection
    const copiedSection = jsonCopyObject(section) 
    copiedSection.linkId = copiedSection.id
    copiedSection.isQuote = true
    copiedSection.id = createId()
    copiedSection.linkedCache = jsonCopyObject(section)

    this.budget.costIds.push(copiedSection.id)
    this.budget.sections[copiedSection.id] = copiedSection
    this.saveBudget()
  }

  async quoteLinkDropdownSelection(id: string, command: ManageBudgetLinkOption) {
    const section = this.budget.sections[id]
    switch (command) {
      case 'remove':
        this.deleteSection(id)
        break
      case 'manage':
        this.manageQuote(id)
        break
      case 'unlink':
        unlinkSectionInPlace(section)
        this.saveBudget()
        break
    }
  }

  async manageQuote(sectionId: string) {
    const section = this.budget.sections[sectionId]
    const quoteId = section.linkId
    const resourceId =  this.budget.quotes[quoteId].resourceId
    console.log({ section, quoteId, resourceId })

    const data: ManageQuoteData = { quoteId, resourceId }
    await openDialogGetResult(this.dialog, ManageQuoteDialogComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
  }


  saveBudget() {
    this.budgetService.updateBudget(this.event.eventId, this.budget)
  }

  updateAssetQuantity(lineItem: LineItem) {
    const asset = this.assets[lineItem.id]
    if (asset.quantity !== lineItem.quantity) this.assetService.upsertAsset({ ...asset, quantity: lineItem.quantity })
  }

  saveSection(section: BudgetSection) {
    this.budget.sections[section.id] = section
    this.saveBudget()
    
  }

  saveSectionSettingDefaults(settings: Partial<SectionSettings>) {
    this.accountService.checkAndUpdateBudgetSectionSettingsDefaults(settings)
  }

  hideCostTip() {
    this.settingsService.hideTipType('cost')
  }

  addSection() {
    const newSection = createEmptySection(this.account, true)
    this.budget.costIds.push(newSection.id)
    this.budget.sections[newSection.id] = newSection
    this.saveBudget()
  }

  async openSnapshot(info: SnapshotInfo) {
    const data: BudgetSnapshotDialogData = { info, eventId: this.event.eventId }
    await openDialogGetResult(this.dialog, BudgetCostsViewDialogComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
  }

  share(event: MouseEvent) {
    console.log("Sharing?")
  }

  moveUp(i: number) {
    this.budget.costIds = moveIndexItemUpInList(i, this.budget.costIds)
    this.saveBudget()
  }

  moveDown(i: number) {
    this.budget.costIds = moveIndexItemDownInList(i, this.budget.costIds)
    this.saveBudget()
  }

  async budgetTasksDropdownSelection(command: ManageBudgetLinkOption) {
    const section = this.budget.sections.tasks
    switch (command) {
      case 'remove':
        this.deleteSection('tasks')
        break
      case 'manage':
        this.manageTasks()
        break
      case 'unlink':
        unlinkSectionInPlace(section)
        section.id = createId()
        section.schedule = createEmptyBudgetSchedule() // cost sections need schedules
        this.budget.costIds[this.budget.costIds.findIndex(id => id === 'tasks')] = section.id
        this.budget.sections[section.id] = section
        delete this.budget.sections.tasks

        const linkedSection = Object.values(this.budget.sections).find(s => s.linkId === 'tasks')
        linkedSection.linkId = section.id

        this.saveBudget()
        break
    }
  }

  async budgetAssetsDropdownSelection(command: ManageBudgetLinkOption) {
    const section = this.budget.sections.assets
    switch (command) {
      case 'remove':
        this.deleteSection('assets')
        break
      case 'manage':
        this.manageAssets()
        break
      case 'unlink':
        unlinkSectionInPlace(section)
        section.id = createId()
        section.schedule = createEmptyBudgetSchedule() // cost sections need schedules
        this.budget.costIds[this.budget.costIds.findIndex(id => id === 'assets')] = section.id
        this.budget.sections[section.id] = section
        delete this.budget.sections.assets

        const linkedSection = Object.values(this.budget.sections).find(s => s.linkId === 'assets')
        linkedSection.linkId = section.id

        this.saveBudget()
        break
    }
  }

  async manageAssets() {
    const data: AddBudgetToggleItemsData = { section: this.costAssetsToggleSection, isTasks: false }
    console.log({ data })
    const result = await openDialogGetResult<BudgetSection | { delete: true }>(this.dialog, AddBudgetToggleItemsDialogComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
    console.log({ result })
    
    if (!result) return
    if (result.hasOwnProperty('delete')) {
      if (!this.budget.sections.assets) return // nothing to delete
      this.deleteSection('assets')
    } else {
      if (!this.budget.costIds.includes('assets')) this.budget.costIds.push('assets')
      this.budget.sections.assets = result as BudgetSection
    }
    this.saveBudget()
  }

  async manageTasks() {
    const data: AddBudgetToggleItemsData = { section: this.costTasksToggleSection, isTasks: true }
    console.log({ data })
    const result = await openDialogGetResult<BudgetSection | { delete: true }>(this.dialog, AddBudgetToggleItemsDialogComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
    console.log({ result })
    
    if (!result) return
    if (result.hasOwnProperty('delete')) {
      if (!this.budget.sections.tasks) return // nothing to delete
      this.deleteSection('tasks')
    } else {
      if (!this.budget.costIds.includes('tasks')) this.budget.costIds.push('tasks')
      this.budget.sections.tasks = result as BudgetSection
    }
    this.saveBudget()
  }

  async toggleTaskUpdates() {
    this.taskUpdatesOpen = !this.taskUpdatesOpen
  }

  async toggleAssetUpdates() {
    this.assetUpdatesOpen = !this.assetUpdatesOpen
  }

  deleteSection(id: string) {
    this.budget.costIds = deleteItemFromListById(id, this.budget.costIds)
    delete this.budget.sections[id]

    Object.values(this.budget.sections)
      .filter(s => s.linkId === id)
      .map(unlinkSectionInPlace) // unlink all deleted sections
      .forEach(s => s.linkJustDeleted = true) 
      
    this.saveBudget()
  }

  markDeletedLinkSection(id: string) {
    this.budget.sections[id].linkJustDeleted = false
    this.saveBudget()
  }

  async saveSnapshot() {
    this.savingSnapshot = true
    
    const n = this.budget.costSnapshots.length
    const name = n ? `Snapshot ${(+this.budget.costSnapshots[n-1].name.split("Snapshot ")[1] + 1)}` : 'Snapshot 1'

    const info: SnapshotInfo = {
      id: await this.shareService.generateShareCode(),
      name,
      timestamp: new Date().getTime()
    }
    
    console.log({ info })


    await this.eventService.uploadBudgetSnapshot(info, this.budget, 'costs')

    this.budget.costSnapshots.push(info)
    await this.budgetService.updateBudget(this.event.eventId, this.budget)

    this.savingSnapshot = false
  }


}